export default __webpack_public_path__ + "static/media/aspx.4bad788c.svg";